import * as React from "react";
import "../styles/spacer.css";

const Spacer = ({ classes, height }) => {
  let textStyles = {};
  if (height !== undefined) {
    textStyles = {
      minHeight: height + "vh",
    };
  }

  return <div style={textStyles} className={classes}></div>;
};

export default Spacer;
